/* DPC cart add patch: merges 4 properties into any /cart/add or /cart/add.js request */
(function(){
  const KEYS = ['Dog name','Dog original URL','Dog stage1 URL','Dog portrait URL','Portrait URL' ];

  function collectProps(){
    const out = {};
    KEYS.forEach(k => {
      const el = document.querySelector(`input[name="properties[${CSS.escape(k)}]"]`);
      if (el && el.value) out[k] = el.value;
    });
    return Object.keys(out).length ? out : null;
  }
  function isCartAdd(urlLike){
    try {
      const u = new URL(typeof urlLike === 'string' ? urlLike : urlLike.url || '', location.origin);
      return /\/cart\/add(\.js)?$/.test(u.pathname);
    } catch { return false; }
  }

  // fetch patch
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = async function(input, init){
      try {
        const url = typeof input === 'string' ? input : (input && input.url);
        if (!isCartAdd(url)) return origFetch.apply(this, arguments);
        const props = collectProps(); if (!props) return origFetch.apply(this, arguments);
        if (!init || !init.body) return origFetch.apply(this, arguments);
        const headers = new Headers(init.headers || (input && input.headers) || {});
        const ct = (headers.get('Content-Type') || '').toLowerCase();

        if (ct.includes('application/json') && typeof init.body === 'string') {
          try {
            const payload = JSON.parse(init.body || '{}');
            payload.properties = Object.assign({}, payload.properties || {}, props);
            init.body = JSON.stringify(payload);
            return origFetch.call(this, input, init);
          } catch {}
        }
        if (init.body instanceof FormData) {
          Object.entries(props).forEach(([k,v]) => init.body.append(`properties[${k}]`, v));
          return origFetch.call(this, input, init);
        }
        if (typeof init.body === 'string' && (!ct || ct.includes('application/x-www-form-urlencoded'))) {
          const usp = new URLSearchParams(init.body);
          Object.entries(props).forEach(([k,v]) => usp.set(`properties[${k}]`, v));
          init.body = usp.toString();
          headers.set('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
          init.headers = headers;
          return origFetch.call(this, input, init);
        }
        return origFetch.apply(this, arguments);
      } catch { return origFetch.apply(this, arguments); }
    };
  }

  // XHR patch (legacy libs)
  const OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    const Send = OrigXHR.prototype.send;
    const Open = OrigXHR.prototype.open;
    let lastUrl = '';
    OrigXHR.prototype.open = function(method, url){ lastUrl = url; return Open.apply(this, arguments); };
    OrigXHR.prototype.send = function(body){
      try {
        if (isCartAdd(lastUrl)) {
          const props = collectProps();
          if (props) {
            if (body instanceof FormData) {
              Object.entries(props).forEach(([k,v]) => body.append(`properties[${k}]`, v));
            } else if (typeof body === 'string') {
              try { const obj = JSON.parse(body); obj.properties = Object.assign({}, obj.properties || {}, props); body = JSON.stringify(obj); }
              catch { const usp = new URLSearchParams(body); Object.entries(props).forEach(([k,v]) => usp.set(`properties[${k}]`, v)); body = usp.toString(); }
            }
          }
        }
      } catch {}
      return Send.call(this, body);
    };
  }

  // jQuery ajax patch (if present)
  if (window.jQuery && window.jQuery.ajaxPrefilter) {
    window.jQuery.ajaxPrefilter(function(opts, orig){
      try {
        if (!isCartAdd(opts.url)) return;
        const props = collectProps(); if (!props) return;
        if (opts.contentType && opts.contentType.indexOf('application/json') >= 0 && typeof opts.data === 'string') {
          const obj = JSON.parse(opts.data || '{}'); obj.properties = Object.assign({}, obj.properties || {}, props); opts.data = JSON.stringify(obj);
          return;
        }
        if (orig && orig.data instanceof FormData) {
          Object.entries(props).forEach(([k,v]) => orig.data.append(`properties[${k}]`, v));
          opts.processData = false; opts.contentType = false;
          return;
        }
        const usp = new URLSearchParams(opts.data || '');
        Object.entries(props).forEach(([k,v]) => usp.set(`properties[${k}]`, v));
        opts.data = usp.toString();
        opts.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
      } catch {}
    });
  }
})();


(function () {
  const origFetch = window.fetch;
  window.fetch = async function (input, init) {
    try {
      const url = typeof input === 'string' ? input : (input.url || '');
      if (url.includes('/cart/add.js') && init && init.body) {
        let bodyObj = null;

        // Try to parse JSON payload
        if (typeof init.body === 'string' && init.headers && /json/i.test(init.headers['Content-Type'] || init.headers['content-type'] || '')) {
          try {
            bodyObj = JSON.parse(init.body);
          } catch {}
        }

        if (bodyObj && window.__DPC_PROPS) {
          bodyObj.properties = Object.assign({}, bodyObj.properties || {}, window.__DPC_PROPS);
          init.body = JSON.stringify(bodyObj);
          console.log('[dpcCartPatch] Injected properties into /cart/add.js', bodyObj.properties);
        }
      }
    } catch (e) {
      console.warn('[dpcCartPatch] failed', e);
    }
    return origFetch.apply(this, arguments);
  };
})();